import { render, staticRenderFns } from "./jhi-item-count.vue?vue&type=template&id=2436b7ae&"
import script from "./jhi-item-count.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-item-count.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/backOffice/backOffice/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2436b7ae')) {
      api.createRecord('2436b7ae', component.options)
    } else {
      api.reload('2436b7ae', component.options)
    }
    module.hot.accept("./jhi-item-count.vue?vue&type=template&id=2436b7ae&", function () {
      api.rerender('2436b7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/back-office/jhipster-old/jhi-item-count.vue"
export default component.exports